
import rippleIndicator from "../common/ripple-indicator.vue";
export default {
  components: { rippleIndicator },
  props: {
    item: {},
    currentMinute: 0,
    index: 0
  },
  data() {
    return {
      isCompletedBatch: false,
      isActive: false,
      isUpcomingBatch: false,
      progress: 0
    };
  },
  mounted() {
    setTimeout(
      (() => {
        this.processCurrentMinute(this.currentMinute, null);
      }).bind(this),
      200
    );
  },
  watch: {
    currentMinute(newVal, oldVal) {
      this.processCurrentMinute(newVal, oldVal);
    }
  },
  methods: {
    processCurrentMinute(newVal, oldVal) {
      const batchStartTime = this.getMinutesFromFormattedTime(
        this.item.start_time
      );
      const batchEndTime = this.getMinutesFromFormattedTime(this.item.end_time);
      if (batchStartTime <= newVal && batchEndTime > newVal) {
        this.isActive = true;
        this.isCompletedBatch = false;
        this.isUpcomingBatch = false;
        if (
          oldVal == null ||
          !(batchStartTime <= oldVal && batchEndTime > oldVal)
        ) {
          this.$emit("selectedgroupByItemChange", this.index);
        }
        this.progress =
          ((newVal - batchStartTime) / (batchEndTime - batchStartTime)) * 100;
      } else {
        this.isActive = false;
        if (batchEndTime <= newVal) {
          this.isCompletedBatch = true;
          this.isUpcomingBatch = false;
        } else if (batchStartTime > newVal) {
          this.isUpcomingBatch = true;
          this.isCompletedBatch = false;
        }
      }
    }
  }
};
